"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELETE_ATTRIBUTE = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.DELETE_ATTRIBUTE = (0, gql_1.gql)(`
   mutation deleteAttribute(
    $productLabelValidation: DeleteProductLabelValidationInput!
    $sort: [ProductTreeNodeRelativeOrderBy!]!
  ) {
    deleteProductLabelValidation(productLabelValidation: $productLabelValidation) {
      success
      error
      productTreeNode {
        ancestors(first: 100, sort: $sort) {
          edges {
            node {
              ancestor {
                id
              }
            }
          }
        }
      }
    }
  }
`);
